export default __webpack_public_path__ + "static/media/Avatar-24-noback.719c9258.png";